import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e7e7196e"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("label", null, "产品服务")], -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("label", null, "解决方案")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("label", null, "新闻中心")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("label", null, "关于我们")], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "company-logo"
}, null, -1));
const _hoisted_6 = {
  class: "hot-link"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " 7*24小时客服热线：", -1));
const _hoisted_8 = {
  class: "tel"
};
const _hoisted_9 = {
  class: "code"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "code-name"
};
const _hoisted_12 = {
  class: "other-account"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy-right"
}, [/*#__PURE__*/_createElementVNode("label", null, [/*#__PURE__*/_createTextVNode(" Copyright©2023-2025, hdgyl.com.cn All Rights Reserved. "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/#/Integrated/index"
}, "津ICP备2023001685号-1"), /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019002003070"
}, "陕公网安备61019002003070号")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(["footer-content", {
      entry: _ctx.footer.showTime
    }]),
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("ul", {
    class: _normalizeClass(["product", {
      entry: _ctx.footer.showTime,
      leave: _ctx.footer.showTime
    }])
  }, [_hoisted_1, _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.goLink('/freight'))
  }, "数字货运")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.goLink('/product'))
  }, "数字供应链")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[2] || (_cache[2] = $event => _ctx.goLink('/figureEnertgy'))
  }, "数字能源")])], 2), _createElementVNode("ul", {
    class: _normalizeClass(["project", {
      entry: _ctx.footer.showTime
    }])
  }, [_hoisted_2, _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[3] || (_cache[3] = $event => _ctx.goLink('/product', 'coal'))
  }, "煤炭行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.goLink('/product', 'power'))
  }, "电力行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[5] || (_cache[5] = $event => _ctx.goLink('/product', 'chemical'))
  }, "化工行业")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[6] || (_cache[6] = $event => _ctx.goLink('/product', 'rail'))
  }, "铁路货站")])], 2), _createElementVNode("ul", {
    class: _normalizeClass(["press", {
      entry: _ctx.footer.showTime
    }])
  }, [_hoisted_3, _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[7] || (_cache[7] = $event => _ctx.goLink('/press', 'CompanyNews'))
  }, "公司新闻")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[8] || (_cache[8] = $event => _ctx.goLink('/press', 'PartyNews'))
  }, "党群建设")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[9] || (_cache[9] = $event => _ctx.goLink('/press', 'EnterpriseNews'))
  }, "企业文化")])], 2), _createElementVNode("ul", {
    class: _normalizeClass(["us", {
      entry: _ctx.footer.showTime
    }])
  }, [_hoisted_4, _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[10] || (_cache[10] = $event => _ctx.goLink('/us', 'AboutHuoda'))
  }, "关于货达")]), _createElementVNode("li", null, [_createElementVNode("label", {
    onClick: _cache[11] || (_cache[11] = $event => _ctx.goLink('/us', 'JoinUs'))
  }, "加入我们")])], 2), _createElementVNode("div", {
    class: _normalizeClass(["link-us", {
      entry: _ctx.footer.showTime
    }])
  }, [_hoisted_5, _createVNode(_component_Divider, {
    class: "divider"
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaSchema, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["wx-current-media", {
        active: item.type === _ctx.currentMedialName
      }]),
      key: index
    }, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("label", _hoisted_8, _toDisplayString(item.hotline), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
      src: item.imgPath
    }, null, 8, _hoisted_10)]), _createElementVNode("label", _hoisted_11, _toDisplayString(item.info), 1)], 2);
  }), 128)), _createElementVNode("div", _hoisted_12, [_createTextVNode(" 官方全媒体账号： "), _createElementVNode("label", null, [_createElementVNode("i", {
    class: _normalizeClass(["font_family icon-weixin", {
      'icon-active': _ctx.currentMedialName === 'wx'
    }]),
    onMouseenter: _cache[12] || (_cache[12] = $event => _ctx.mediaBlurHandle('wx'))
  }, null, 34), _createElementVNode("i", {
    class: _normalizeClass(["font_family icon-douyin", {
      'icon-active': _ctx.currentMedialName === 'dy'
    }]),
    onMouseenter: _cache[13] || (_cache[13] = $event => _ctx.mediaBlurHandle('dy'))
  }, null, 34), _createElementVNode("i", {
    class: _normalizeClass(["font_family icon-weixinshipin", {
      'icon-active': _ctx.currentMedialName === 'wxsp'
    }]),
    onMouseenter: _cache[14] || (_cache[14] = $event => _ctx.mediaBlurHandle('wxsp'))
  }, null, 34), _createElementVNode("i", {
    class: _normalizeClass(["font_family icon-kuaishou", {
      'icon-active': _ctx.currentMedialName === 'ks'
    }]),
    onMouseenter: _cache[15] || (_cache[15] = $event => _ctx.mediaBlurHandle('ks'))
  }, null, 34)])])], 2)], 6), _hoisted_13], 64);
}